import { useEffect, useState } from "react";
import api from "@/lib/api";
import DashboardShell from "@/components/nav/DashboardShell";

export default function Reports() {
  const [data, setData] = useState(null);
  const [range, setRange] = useState("week");

  useEffect(() => {
    api.get(`/reports/summary?range=${range}`).then(({data}) => setData(data)).catch(() => {});
  }, [range]);

  return (
    <DashboardShell>
      <div className="brand-eyebrow mb-4">RESULTS</div>
      <h1 className="brand-headline text-4xl md:text-6xl mb-8">Reports.</h1>

      <div className="flex gap-2 mb-8">
        {["today","week","month"].map(r => (
          <button key={r} data-testid={`reports-range-${r}`} onClick={() => setRange(r)}
            className={`text-[10px] tracking-widest font-bold px-3 py-1.5 border ${range===r ? "bg-gold text-ink border-gold" : "text-smoke border-line hover:border-gold"}`}>{r.toUpperCase()}</button>
        ))}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        <Stat label="Tasks completed" value={data?.tasks_completed ?? "—"} />
        <Stat label="Emails handled" value={data?.emails_sent ?? "—"} />
        <Stat label="Follow-ups" value={data?.followups ?? "—"} />
        <Stat label="Records updated" value={data?.records_updated ?? "—"} />
      </div>

      <div className="card-white p-10">
        <div className="brand-eyebrow" style={{color:'#0B0D10'}}>ROI (ESTIMATE)</div>
        <div className="text-ink/60 text-xs mt-2">Every number below is an estimate based on category benchmarks — not billing.</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mt-8">
          <BigStat label="Staff time saved" value={data?.estimates?.staff_time_saved_hours ?? 0} suffix="hrs" />
          <BigStat label="Labor value" value={`$${data?.estimates?.labor_value_usd ?? 0}`} />
          <BigStat label="Subscription cost" value={`$${data?.estimates?.subscription_cost_usd ?? 0}`} />
          <BigStat label="Operational value" value={`$${data?.estimates?.operational_value_usd ?? 0}`} accent />
        </div>
        <div className="text-ink/50 text-xs mt-8">Assumptions: {data?.estimates?.minutes_per_task_used} min/task · ${data?.estimates?.hourly_rate_used}/hr comparable rate.</div>
      </div>
    </DashboardShell>
  );
}

function Stat({ label, value }) {
  return (
    <div className="border border-line p-6">
      <div className="brand-eyebrow">{label.toUpperCase()}</div>
      <div className="brand-headline text-5xl mt-3 text-white">{value}</div>
    </div>
  );
}
function BigStat({ label, value, suffix, accent }) {
  return (
    <div>
      <div className="text-[11px] tracking-widest text-ink/60 font-bold">{label.toUpperCase()}</div>
      <div className={`brand-headline text-4xl md:text-5xl mt-3 ${accent ? "text-gold" : "text-ink"}`}>
        {value}{suffix && <span className="text-lg ml-1 text-ink/50 font-normal">{suffix}</span>}
      </div>
    </div>
  );
}
